<template>
  <v-app>
    <v-toolbar v-if="isAuthenticated"  flat app style="z-index:20; background-color:#222">
      <!-- <v-toolbar-side-icon class="grey--text" @click="drawer = !drawer"></v-toolbar-side-icon>
      <span class="hidden-sm-and-up">
        <v-toolbar-side-icon  @click="drawer = !drawer"></v-toolbar-side-icon>
      </span> -->

      <!-- toolbar icon that direct to home page -->
      <v-toolbar-title class="white--text vv-logo">
        <router-link to="/home" tag="span" style="cursor: pointer">
          <img id="logo" src="./assets/logo.gif">
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Toolbar display user name  -->
      <v-toolbar-items class="hidden-xs-only" >
        <v-menu offset-y>
          <v-btn flat slot="activator" style="text-transform:capitalize; color:#fff">
            <v-icon left>person</v-icon>
            {{username}}
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="item in menuItems"
              :key="item.title"
              :to="item.path"
            >
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
                <v-icon right>{{ item.icon }}</v-icon>
            </v-list-tile>
            <v-list-tile
              @click="userSignOut"
              v-if="isAuthenticated"
            >
              <v-list-tile-title>Sign Out</v-list-tile-title>
              <v-icon right>exit_to_app</v-icon>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <!-- <v-navigation-drawer temporary absolute v-model="drawer"  v-if="isAuthenticated" app>
      <v-list>
        <v-list-tile
          v-for="item in toolbarItems1"
          :key="item.title"
          :to="item.path">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile> -->
        <!-- <v-list-group
          v-for="item in ExpansionItems"
          :key="item.title"
          v-model="item.active"
          :prepend-icon="item.action"
          :to="item.path">
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="subItem.path">
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>{{ subItem.action }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group> -->
        <!-- <v-list-tile
          v-for="item in toolbarItems2"
          :key="item.title"
          :to="item.path">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="userSignOut" v-if="isAuthenticated">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Sign Out</v-list-tile-content>
        </v-list-tile> -->
      <!-- </v-list>
    </v-navigation-drawer> -->
  <v-content>
    <router-view :key="$route.fullPath">
    </router-view>
  </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      drawer: false,
      isList: false,
      appTtile: 'iBegoo'
    }
  },
  computed: {
    username () {
      let email = this.$store.state.user.email
      // computed the user name format
      return 'Welcome ' + email.match(/([a-zA-Z0-9-_.]+)/gi)[0]
    },
    appTitle () {
      return this.$store.state.appTitle
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    // toolbarItems1 () {
    //   if (this.isAuthenticated) {
    //     return [
    //       // { title: 'Create Story', path: '/storylistCreate', icon: 'add' },
    //       { title: 'Story List', path: '/storylist', icon: 'book' },
    //       { title: 'Asset', path: '/assets', icon: 'build' }

    //     ]
    //   } else {
    //     return [
    //       { title: 'Sign Up', path: '/signup', icon: 'face' },
    //       { title: 'Sign In', path: '/signin', icon: 'lock_open' }
    //     ]
    //   }
    // },
    // ExpansionItems () {
    //   if (this.isAuthenticated) {
    //     return [
    //       {
    //         drawer: true,
    //         action: 'build',
    //         title: 'Asset',
    //         active: true,
    //         items: [
    //           { title: 'Set Design', path: 'assets' },
    //           { title: 'Prop' },
    //           { title: 'Character Action' },
    //           { title: 'Character Model' },
    //           { title: 'Scene Name' },
    //           { title: 'Voice' },
    //           { title: 'Prop Action' },
    //           { title: 'Sound' }
    //         ]
    //       }
    //     ]
    //   } else {
    //     return [
    //       { title: 'Sign Up', path: '/signup', icon: 'face' },
    //       { title: 'Sign In', path: '/signin', icon: 'lock_open' }
    //     ]
    //   }
    // },
    // toolbarItems2 () {
    //   if (this.isAuthenticated) {
    //     return [
    //       { title: 'Demo', path: '/welcome', icon: 'label' },
    //       { title: 'Edit Profile', path: '/editprofile', icon: 'person_outline' },
    //       { title: 'Contact', path: '/contact', icon: 'email' },
    //       { title: 'FAQ', path: '/faq', icon: 'help_outline' }
    //       // { title: 'Edit Profile', path: '/editprofile' },
    //       // { title: 'Stories', path: '/storylist' },
    //       // { title: 'Assets', path: '/assets' }
    //     ]
    //   } else {
    //     return [
    //       { title: 'Sign Up', path: '/signup', icon: 'face' },
    //       { title: 'Sign In', path: '/signin', icon: 'lock_open' }
    //     ]
    //   }
    // },

    // menu contents list, please make sure you define the route in router's folder
    menuItems () {
      if (this.isAuthenticated) {
        return [
          { title: 'Profile', path: '/profile', icon: 'person_outline' },
          { title: 'Stories', path: '/storylist', icon: 'book' },
          { title: 'Assets', path: '/assets', icon: 'build' },
          { title: 'API Calls', path: '/userclass', icon: 'group' }
          // { title: 'temp', path: '/temp', icon: 'face' }
        ]
      } else {
        return [
          { title: 'Sign Up', path: '/signup', icon: 'face' },
          { title: 'Sign In', path: '/signin', icon: 'lock_open' }
        ]
      }
    }
  },
  methods: {
    userSignOut () {
      this.$store.dispatch('userSignOut')
    }
  }
}
</script>

<style scoped lang="scss">
.vv-logo {
  display: flex;
  align-items: center;
  margin: 0;
  cursor: pointer;
  img {
    max-width: 120px;
    height:30px;
    margin-right: 10px;
    margin-top: 5px;
  }
}

// .vv-toolbar {
//   z-index: 25;
// }

</style>



// WEBPACK FOOTER //
// src/App.vue